import React, { Fragment, useCallback } from "react";
import Button from "./CustomButton";
import VariantForm from "./VariantForm";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import Icon from "@fortawesome/react-fontawesome";
import useToggle from "./useToggle";

const AddVariantButton = ({ onSubmitVariant }) => {
  const { toggle, isOpen, hide } = useToggle(false);
  const onSubmit = useCallback(
    data => {
      onSubmitVariant(data);
      hide();
    },
    [hide, onSubmitVariant]
  );
  return (
    <Fragment>
      <Modal isOpen={isOpen} toggle={toggle} onExit={() => {}} size="xl">
        <ModalHeader>
          Add Variant <Icon icon="plus" />
        </ModalHeader>
        <ModalBody>
          <VariantForm onSubmit={onSubmit} hide={hide} />
        </ModalBody>
      </Modal>
      <Button onClick={toggle} color="info" simple>
        Add Variant <Icon icon="plus-circle" />
      </Button>
    </Fragment>
  );
};

export default AddVariantButton;
